var map = {
	"./bigcartel-icon_dark.svg": 601641,
	"./bigcommerce-icon_dark.svg": 830389,
	"./etsy-icon_dark.svg": 956311,
	"./shopify-icon_dark.svg": 70500,
	"./squarespace-icon_dark.svg": 334203,
	"./woocommerce-icon_dark.svg": 938438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 752340;